module.exports = __webpack_public_path__ + "media/map/SC_Icon-da27806a.png";